import { Style, styled } from 'inlines'
import { useState, useEffect } from 'react'
import { resizeImage } from '@app/util/helpers'
import useMediaQuery from '@app/util/useMediaQuery'

export type ImageProps = {
  style?: Style
  src: string
  alt?: string
  onClick?: (e: React.MouseEvent) => void
  onLoad?: () => void
  onError?: () => void
  resizeWidth?: number
  resizeHeight?: number
  ignoreResize?: boolean
}

export const Image = ({
  style,
  src,
  alt,
  resizeWidth,
  resizeHeight,
  ignoreResize = false,
  onClick,
  onLoad,
  onError,
}: ImageProps) => {
  const isMobile = useMediaQuery()
  const [hasError, setHasError] = useState(false)

  // Reset error state when src changes
  useEffect(() => {
    setHasError(false)
  }, [src])

  const handleError = () => {
    onError?.()
    setHasError(true)
  }

  if (hasError) {
    return null
  }

  const defaultResizeWidth = isMobile ? 800 : 1280
  const dimension = resizeHeight ? 'h' : 'w'
  const value = resizeHeight ?? resizeWidth ?? defaultResizeWidth
  const resizedSrc = ignoreResize
    ? src
    : resizeImage(src, value, dimension, isMobile)

  return (
    <styled.img
      src={resizedSrc}
      alt={alt || ''}
      onClick={onClick}
      onLoad={onLoad}
      onError={handleError}
      draggable="false"
      style={style}
    />
  )
}
